var ShippingErrorModalController = /** @class */ (function () {
    /* @ngInject*/
    function ShippingErrorModalController(params, $mdDialog, CartService, $scope) {
        var _this = this;
        this.$mdDialog = $mdDialog;
        this.CartService = CartService;
        this.$scope = $scope;
        this.itemsAdjusted = params.itemsAdjusted;
        this.errorCode = params.errorCode;
        console.log(params);
        this.$scope.$on('sendItemsAdjusted', function (event, data) {
            _this.itemsAdjusted = data;
        });
    }
    ShippingErrorModalController.prototype.closeAlert = function (option) {
        this.$scope.$broadcast('getItemsAdjusted', {});
        var res = {
            option: option,
            itemsAdjusted: this.itemsAdjusted
        };
        this.$mdDialog.hide(res);
    };
    return ShippingErrorModalController;
}());
export default ShippingErrorModalController;
//# sourceMappingURL=shipping-error-modal.controller.js.map